// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml_obj from "@rescript/std/lib/es6/caml_obj.js";
import * as $$Date from "@artegeie/date";

var WeekStartsOn = {
  sunday: 0,
  monday: 1,
  tuesday: 2,
  wednesday: 3,
  thursday: 4,
  friday: 5,
  saturday: 6
};

function dateToAdverbOfTime(date) {
  var match = $$Date.isTomorrow(date);
  var match$1 = $$Date.isToday(date);
  var match$2 = $$Date.isYesterday(date);
  if (match) {
    return /* Tomorrow */2;
  } else if (match$1) {
    return /* Today */0;
  } else if (match$2) {
    return /* Yesterday */1;
  } else {
    return /* Other */3;
  }
}

function compareDay(referenceDate, dateToCompare) {
  if ($$Date.isSameDay(referenceDate, dateToCompare)) {
    return /* Equal */0;
  } else if (Caml_obj.lessthan(referenceDate, dateToCompare)) {
    return /* Greater */1;
  } else {
    return /* Lower */2;
  }
}

function compareDatewithTodayPlusTwoWeeks(today, date) {
  var todayStartOfWeek = $$Date.startOfWeek(today, /* Fr */0, 1);
  var dateStartOfWeek = $$Date.startOfWeek(date, /* Fr */0, 1);
  return compareDay($$Date.addWeeks(todayStartOfWeek, 2), dateStartOfWeek);
}

var Format = {
  fullWeekDay: "eeee"
};

function range(startDate, numberOfDays) {
  var acc = [];
  var _date = startDate;
  var _numberOfDays = numberOfDays;
  while(true) {
    var numberOfDays$1 = _numberOfDays;
    var date = _date;
    if (numberOfDays$1 === 0) {
      return acc;
    }
    acc.push(date);
    _numberOfDays = numberOfDays$1 - 1 | 0;
    _date = $$Date.addDays(date, 1);
    continue ;
  };
}

function updateTime(date, hours, minutes) {
  var dateWithTime = new Date(date);
  dateWithTime.setHours(hours);
  dateWithTime.setMinutes(minutes);
  return dateWithTime;
}

export {
  WeekStartsOn ,
  dateToAdverbOfTime ,
  compareDay ,
  compareDatewithTodayPlusTwoWeeks ,
  Format ,
  range ,
  updateTime ,
}
/* @artegeie/date Not a pure module */
